export const Orientation = {
  LANDSCAPE: "L",
  PORTRAIT: "P",
};

export const Platform = {
  AND: "android",
  IOS: "ios",
  WEB: "web",
  TAB: "tab",
};
